import { games } from '@/modules/players/v2/tabs/overview/TournamentResults/constants';
import { GameScore } from '@/modules/players/v2/tabs/overview/TournamentResults/types';
import { getGameScores } from '@/modules/players/v2/tabs/overview/TournamentResults/utils';
import { PlayerLiveGameStatusData } from '@/types/players.types';

interface ScoresProps {
  match: PlayerLiveGameStatusData;
  userId: string;
}

const Scores = ({ match, userId }: ScoresProps) => {
  const gameScores = getGameScores(match, userId);

  return (
    <div className='hidden gap-x-6 px-4 sm:flex'>
      {games.map((game, index) => {
        const score: GameScore = gameScores[index] || {
          userScore: '',
          opponentScore: '',
        };
        const hasScores = score.userScore !== '' || score.opponentScore !== '';
        if (!hasScores) return null;

        const firstScore = score.isTeamOne ? score.userScore : score.opponentScore;
        const secondScore = score.isTeamOne ? score.opponentScore : score.userScore;

        const isEqual = parseInt(firstScore) === parseInt(secondScore);
        const isFirstWinning = parseInt(firstScore) > parseInt(secondScore);

        return (
          <div key={game} className='flex flex-col text-center'>
            <p className='text-xs text-gray-900'>{game}</p>
            {score.forfeitMessage ? (
              <p className='text-lg text-gray-900'>{score.forfeitMessage}</p>
            ) : (
              <>
                <p
                  className={`text-lg ${isEqual ? 'text-gray-900' : isFirstWinning ? 'text-green-600' : 'text-gray-900'}`}
                >
                  {firstScore}
                </p>
                <p
                  className={`text-lg ${isEqual ? 'text-gray-900' : !isFirstWinning ? 'text-green-600' : 'text-gray-900'}`}
                >
                  {secondScore}
                </p>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Scores;
